"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
__exportStar(require("./strings"), exports);
__exportStar(require("./enums"), exports);
__exportStar(require("./shared"), exports);
__exportStar(require("./utils"), exports);
__exportStar(require("./serialization"), exports);
__exportStar(require("./host-capabilities"), exports);
__exportStar(require("./host-config"), exports);
__exportStar(require("./registry"), exports);
__exportStar(require("./card-object"), exports);
__exportStar(require("./card-elements"), exports);
__exportStar(require("./table"), exports);
__exportStar(require("./channel-adapter"), exports);
__exportStar(require("./activity-request"), exports);
__exportStar(require("./adaptive-applet"), exports);
//# sourceMappingURL=adaptivecards.js.map